import { Footer as MFooter } from '@burna/monster-design-system';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';

function Footer() {
  return (
    <div className={styles.footer}>
      <MFooter>
        <MFooter.Start>
          <MFooter.Text>
            Powered by <strong>Monster</strong>
          </MFooter.Text>
        </MFooter.Start>
        <MFooter.End>
          <Link to="/help" className={styles.helpLink}>
            Help
          </Link>
          <MFooter.Link href="//burna.ir">About Us</MFooter.Link>
        </MFooter.End>
      </MFooter>
    </div>
  );
}

export default Footer;
